/*
 * Copyright 2026 ByOmakase, LLC (https://byomakase.org)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export enum WindowPlaybackMode {
  ATTACHED = 'ATTACHED',
  DETACHING = 'DETACHING',
  DETACHED = 'DETACHED',
  ATTACHING = 'ATTACHING',
  FAILURE = 'FAILURE',
}

export interface WindowPlayback {
  /** Current window playback mode. */
  mode: WindowPlaybackMode;
  /** Error message set when the mode transitions to `FAILURE`. */
  error?: string | undefined;
  /** Whether the player can currently be detached. */
  canDetach: boolean;
  /** Whether the player can currently be re-attached. */
  canAttach: boolean;
}
